import { render, staticRenderFns } from "./LF.vue?vue&type=template&id=87baaa94&scoped=true&"
import script from "./LF.vue?vue&type=script&lang=js&"
export * from "./LF.vue?vue&type=script&lang=js&"
import style0 from "./LF.vue?vue&type=style&index=0&id=87baaa94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87baaa94",
  null
  
)

export default component.exports